import Vue from 'vue';

/**
 *  @license MIT https://github.com/TahaSh/vue-closable/blob/master/LICENSE
 *  @author Taha Shashtari, Telia Company
 *  @Copyright Original (c) 2019 Taha Shashtari, Modifications (c) 2019 Telia Company
 *  @url https://github.com/TahaSh/vue-closable
 */
var closable = Vue.directive('closable', {
  bind: function (el, binding, vnode) {
    /*
     Directives are "stateless", but every instance need a persistent
     reference to the event listener - so we store it "on" the target
     element.
     */
    el._closableEventListener = createListener(el, binding, vnode);

    closableHelper(
      binding.value.visibility,
      vnode.context,
      el._closableEventListener
    );
  },

  update: function (el, binding, vnode) {
    closableHelper(
      binding.value.visibility,
      vnode.context,
      el._closableEventListener
    );
  },

  unbind: function (el) {
    document.removeEventListener('click', el._closableEventListener);
  }
});

function closableHelper(visibilityName, context, listener) {
  var visibility = evaluateVisibility(visibilityName, context);
  if (visibility) {
    document.addEventListener('click', listener);
  } else {
    document.removeEventListener('click', listener);
  }
}

function evaluateVisibility(visibilityName, dataAndProps) {
  // Backwards-compatible behavior - if visibility is unspecified, we must assume that the directive should be active
  if (visibilityIsUnspecified()) {
    return true
  }

  // Get the value of the specified data/prop
  return dataAndProps[visibilityName]

  function visibilityIsUnspecified() {
    return visibilityName === undefined
  }
}

function createListener(el, binding, vnode) {
  return function(event) {
    var ref = binding.value;
    var exclude = ref.exclude;
    var handler = ref.handler;

    var clickedOnExcludedEl = exclude.some(refWasClicked);

    if (!(el.contains(event.target) || clickedOnExcludedEl)) {
      vnode.context[handler]();
    }

    function refWasClicked(refName) {
      return vnode.context.$refs[refName].contains(event.target)
    }
  }
}

export default closable;
